import { Component, inject } from '@angular/core';
import { ServicesService } from '../my-profile/services.service';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { UserDetailsService } from '../services/user-details.service';
import { ApiServicesService } from '../services/api-services.service';
import { Subscription } from 'rxjs';
import { SocketService } from '../services/socket.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser,faEnvelope,faGear,faEllipsis} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-profile-icons',
  standalone: true,
  imports: [ FontAwesomeModule,RouterLink,RouterLinkActive],
  templateUrl: './profile-icons.component.html',
  styleUrl: './profile-icons.component.css'
})
export class ProfileIconsComponent {

  total_notification: number = 5;
  private taskservices = inject(ServicesService);
  viewed: any = '';
  userData: any;
  name: any;
  total_friendrequest: any;
  fauser=faUser
  faEnvelope=faEnvelope
  faSettings=faGear
  famore=faEllipsis

  unreadMessageCount: number = 0;
  private subscription!: Subscription;
  private subscription2!: Subscription;

  constructor(private userdetails: UserDetailsService,
    private router: Router, private route: ActivatedRoute, private api: ApiServicesService,private socketService: SocketService) {
  }

  ngOnInit(){
    // this.userdetails.userdetails$.subscribe((userData) => {
    //   if (userData && userData.user) {
    //     const is_myProfile = this.api.checkProfile(userData.user.username);
    //     if (is_myProfile) {
    //       this.userData = userData;
    //       this.name=this.userData.user.username;
    //       this.total_notification=this.userData.totalUnreadMessages
    //       this.total_friendrequest=this.userData.totalPendingFriendRequests
    //       if (!this.socketService.isConnected) {
    //         this.setupSocketListeners();
    //       }
          
    //     }
    //   }
    // });



    this.userdetails.friendsCount$.subscribe((userData) => {
      this.total_friendrequest = userData;
    });

    this.userdetails.messageCount$.subscribe((userData) => {
      this.total_notification = userData;
    });


  }

  ngOnDestroy(){
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.subscription2) {
      this.subscription2.unsubscribe();
    }
  }



  private setupSocketListeners(): void {
    // if (this.subscription) {
    //   this.subscription.unsubscribe();
    // }

    // if (this.subscription2) {
    //   this.subscription2.unsubscribe();
    // }

    // // Subscribe to 'unreadCount' event
    // this.subscription = this.socketService.on('unreadCount').subscribe((count: number) => {
    //     this.total_notification = count;
    // });

    // // Subscribe to 'pendingFriendRequestCount' event
    // this.subscription2 = this.socketService.on('pendingFriendRequestCount').subscribe((friendRequest: number) => {
    //   this.total_friendrequest = friendRequest;
    // });
  }



  viewed_tab(view: any) {
    this.taskservices.close_task(view);
    this.taskservices.changefriTab(1);
    // this.router.navigate(["/my-profile", this.name, view]);
  }
}

